module.exports = __webpack_public_path__ + "static/ayabrown-0b8e6e2c538b2250d9b0fcd9430aa790.png";